module.exports = __webpack_public_path__ + "26850e25ae8eccc18304d24d819d9395.png";